import Vue from 'vue';

export default Vue.extend({
  data: () => ({
    toast: {
      type    : 'default',
      icon    : null,
      message : '',
      value   : false
    }
  })
});
